// "use client";

// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// export default function AddProductPage ({ isEdit = false, editingItem = null, onSectionChange }) {
//     const [categories, setCategories] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [imagePreview, setImagePreview] = useState("");
//     const navigate = useNavigate();

//     const [formData, setFormData] = useState({
//         product_name: "",
//         description: "",
//         short_description: "",
//         price: "",
//         inventory: "",
//         category_id: "",
//         image: null,
//     });

//     // Fetch categories on component mount
//     useEffect(() => {
//         const fetchCategories = async () => {
//             try {
//                 const response = await fetch("https://leapatinternational.com/admin/api/v1/category.php");

//                 if (!response.ok) {
//                     throw new Error(`HTTP error! Status: ${response.status}`);
//                 }

//                 const result = await response.json();
//                 setCategories(result.data || []);
//             } catch (error) {
//                 console.error("Error fetching categories:", error);
//                 toast.error("Failed to load categories");
//                 setCategories([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchCategories();
//     }, []);

//     // Cleanup object URLs to prevent memory leaks
//     useEffect(() => {
//         return () => {
//             if (imagePreview && imagePreview.startsWith('blob:')) {
//                 URL.revokeObjectURL(imagePreview);
//             }
//         };
//     }, [imagePreview]);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     const handleImageUpload = (e) => {
//         const file = e.target.files[0];

//         if (file) {
//             // Set the file in formData
//             setFormData(prev => ({
//                 ...prev,
//                 image: file
//             }));

//             // Create preview URL
//             const previewUrl = URL.createObjectURL(file);
//             setImagePreview(previewUrl);
//         } else {
//             // Clear preview if no file selected
//             setFormData(prev => ({
//                 ...prev,
//                 image: null
//             }));
//             setImagePreview("");
//         }
//     };

//     const handleRemoveImage = () => {
//         // Revoke the current object URL
//         if (imagePreview && imagePreview.startsWith('blob:')) {
//             URL.revokeObjectURL(imagePreview);
//         }

//         setFormData(prev => ({
//             ...prev,
//             image: null
//         }));
//         setImagePreview("");

//         // Clear the file input
//         const fileInput = document.querySelector('input[type="file"]');
//         if (fileInput) {
//             fileInput.value = '';
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsSubmitting(true);

//         try {
//             const data = new FormData();
//             data.append("product_name", formData.product_name);
//             data.append("description", formData.description);
//             data.append("short_description", formData.short_description);
//             data.append("price", formData.price);
//             data.append("inventory", formData.inventory);
//             data.append("category_id", formData.category_id);

//             if (formData.image) {
//                 data.append("image", formData.image);
//             }

//             const endpoint = "https://leapatinternational.com/admin/api/v1/product_add.php";

//             const response = await fetch(endpoint, {
//                 method: "POST",
//                 body: data,
//             });

//             const result = await response.json();

//             if (result.ok === true || result.status === "success") {
//                 toast.success("Product created successfully!");
//                 navigate('/dashboard/products');
//             } else {
//                 toast.error(result.message || "Failed to create product");
//             }
//         } catch (err) {
//             console.error("Error:", err);
//             toast.error("Network error. Please try again.");
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     const handleCancel = () => {
//         if (onSectionChange) {
//             onSectionChange("products");
//         } else {
//             navigate('/dashboard/products');
//         }
//     };

//     if (loading) {
//         return (
//             <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
//                 <div className="spinner-border" role="status">
//                     <span className="visually-hidden">Loading...</span>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="category-management-section">
//             {/* Page Header */}
//             <div className="row mb-4">
//                 <div className="col-12">
//                     <div className="d-flex align-items-center mb-3">
//                         <button className="btn btn-outline-secondary me-3" onClick={handleCancel}>
//                             ← Back to Products
//                         </button>
//                         <div>
//                             <h1 className="page-title mb-0">
//                                 {isEdit ? "Edit Product" : "Add New Product"}
//                             </h1>
//                             <p className="page-subtitle mb-0">
//                                 {isEdit ? "Update product information" : "Create a new product listing"}
//                             </p>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Form */}
//             <div className="row">
//                 <div className="col-lg-12">
//                     <div className="card">
//                         <div className="card-header">
//                             <h5 className="card-title mb-0">Product Information</h5>
//                         </div>
//                         <div className="card-body">
//                             <form onSubmit={handleSubmit}>
//                                 <div className="row">
//                                     {/* Left Column */}
//                                     <div className="col-md-6">
//                                         <div className="mb-4">
//                                             <label className="form-label">Product Name *</label>
//                                             <input
//                                                 type="text"
//                                                 className="form-control"
//                                                 name="product_name"
//                                                 value={formData.product_name}
//                                                 onChange={handleInputChange}
//                                                 placeholder="Enter product name"
//                                                 required
//                                             />
//                                             <div className="form-text">Choose a clear, descriptive name for your product</div>
//                                         </div>

//                                         <div className="mb-4">
//                                             <label className="form-label">Category *</label>
//                                             <select
//                                                 className="form-select"
//                                                 name="category_id"
//                                                 value={formData.category_id}
//                                                 onChange={handleInputChange}
//                                                 required
//                                             >
//                                                 <option value="">Select a category</option>
//                                                 {categories.map((category) => (
//                                                     <option key={category.id} value={category.id}>
//                                                         {category.title}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                             <div className="form-text">Choose the most appropriate category for this product</div>
//                                         </div>

//                                         <div className="row">
//                                             <div className="col-md-6">
//                                                 <div className="mb-4">
//                                                     <label className="form-label">Price *</label>
//                                                     <input
//                                                         type="number"
//                                                         className="form-control"
//                                                         name="price"
//                                                         value={formData.price}
//                                                         onChange={handleInputChange}
//                                                         placeholder="0.00"
//                                                         min="0"
//                                                         step="0.01"
//                                                         required
//                                                     />
//                                                     <div className="form-text">Enter product price</div>
//                                                 </div>
//                                             </div>
//                                             <div className="col-md-6">
//                                                 <div className="mb-4">
//                                                     <label className="form-label">Inventory *</label>
//                                                     <input
//                                                         type="number"
//                                                         className="form-control"
//                                                         name="inventory"
//                                                         value={formData.inventory}
//                                                         onChange={handleInputChange}
//                                                         placeholder="0"
//                                                         min="0"
//                                                         required
//                                                     />
//                                                     <div className="form-text">Available stock quantity</div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* Right Column */}
//                                     <div className="col-md-6">
//                                         <div className="mb-4">
//                                             <label className="form-label">Product Image</label>
//                                             <input
//                                                 type="file"
//                                                 className="form-control"
//                                                 accept="image/*"
//                                                 onChange={handleImageUpload}
//                                             />
//                                             <div className="form-text">Upload a high-quality product image (JPG, PNG, GIF)</div>

//                                             {imagePreview && (
//                                                 <div className="mt-3">
//                                                     <label className="form-label">Image Preview</label>
//                                                     <div className="image-preview-container position-relative">
//                                                         <img
//                                                             src={imagePreview}
//                                                             alt="Product preview"
//                                                             className="img-thumbnail"
//                                                             style={{ width: "200px", height: "200px", objectFit: "cover" }}
//                                                         />
//                                                         <button
//                                                             type="button"
//                                                             className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
//                                                             onClick={handleRemoveImage}
//                                                             style={{ transform: "translate(25%, -25%)" }}
//                                                         >
//                                                             ×
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Full Width Fields */}
//                                 <div className="mb-4">
//                                     <label className="form-label">Short Description</label>
//                                     <textarea
//                                         className="form-control"
//                                         name="short_description"
//                                         value={formData.short_description}
//                                         onChange={handleInputChange}
//                                         rows="2"
//                                         placeholder="Enter a brief product summary"
//                                     ></textarea>
//                                     <div className="form-text">Brief summary of the product (optional)</div>
//                                 </div>

//                                 <div className="mb-4">
//                                     <label className="form-label">Product Description</label>
//                                     <textarea
//                                         className="form-control"
//                                         name="description"
//                                         value={formData.description}
//                                         onChange={handleInputChange}
//                                         rows="5"
//                                         placeholder="Enter detailed product description"
//                                     ></textarea>
//                                     <div className="form-text">Provide detailed information about the product features and benefits</div>
//                                 </div>

//                                 <div className="d-flex gap-2 pt-3 border-top">
//                                     <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
//                                         {isSubmitting ? (
//                                             <>
//                                                 <span className="spinner-border spinner-border-sm me-2"></span>
//                                                 {isEdit ? "Updating..." : "Creating..."}
//                                             </>
//                                         ) : (
//                                             <>{isEdit ? "Update Product" : "Create Product"}</>
//                                         )}
//                                     </button>
//                                     <button
//                                         type="button"
//                                         className="btn btn-outline-secondary"
//                                         onClick={handleCancel}
//                                         disabled={isSubmitting}
//                                     >
//                                         Cancel
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }



"use client";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function AddProductPage ({ isEdit = false, editingItem = null, onSectionChange }) {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [imagePreviews, setImagePreviews] = useState([]);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        product_name: "",
        description: "",
        short_description: "",
        price: "",
        inventory: "",
        category_id: "",
        images: [], // Changed from single image to images array
    });
    // Fetch categories on component mount
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch("https://leapatinternational.com/admin/api/v1/category.php");

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                setCategories(result.data || []);
            } catch (error) {
                console.error("Error fetching categories:", error);
                toast.error("Failed to load categories");
                setCategories([]);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    // Cleanup object URLs to prevent memory leaks
    useEffect(() => {
        return () => {
            imagePreviews.forEach(preview => {
                if (preview.url && preview.url.startsWith('blob:')) {
                    URL.revokeObjectURL(preview.url);
                }
            });
        };
    }, [imagePreviews]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);

        if (files.length === 0) return;

        // Check if adding these files would exceed a reasonable limit (e.g., 10 images)
        const currentImageCount = formData.images.length;



        const newImages = [];
        const newPreviews = [];
        let validFilesCount = 0;

        files.forEach((file, index) => {
            // Check for duplicate files (same name and size)
            const isDuplicate = formData.images.some(existingImg =>
                existingImg.name === file.name && existingImg.file.size === file.size
            );

            if (isDuplicate) {
                toast.warning(`File "${file.name}" is already selected.`);
                return;
            }

            // Validate file type
            if (!file.type.startsWith('image/')) {
                toast.error(`File "${file.name}" is not an image.`);
                return;
            }


            const imageId = Date.now() + index + Math.random();

            newImages.push({
                id: imageId,
                file: file,
                name: file.name
            });

            // Create preview URL
            const previewUrl = URL.createObjectURL(file);
            newPreviews.push({
                id: imageId,
                url: previewUrl,
                name: file.name
            });

            validFilesCount++;
        });

        // Only update if we have valid files
        if (newImages.length > 0) {
            // Update formData with new images
            setFormData(prev => ({
                ...prev,
                images: [...prev.images, ...newImages]
            }));

            // Update previews
            setImagePreviews(prev => [...prev, ...newPreviews]);

            // Show success message
            toast.success(`${validFilesCount} image(s) added successfully!`);
        }

        // Always clear the file input so user can select the same files again if needed
        // or select different files in the next selection
        e.target.value = '';
    };

    const handleRemoveImage = (imageId) => {
        // Find and revoke the object URL
        const previewToRemove = imagePreviews.find(preview => preview.id === imageId);
        if (previewToRemove && previewToRemove.url.startsWith('blob:')) {
            URL.revokeObjectURL(previewToRemove.url);
        }

        // Remove from formData
        setFormData(prev => ({
            ...prev,
            images: prev.images.filter(img => img.id !== imageId)
        }));

        // Remove from previews
        setImagePreviews(prev => prev.filter(preview => preview.id !== imageId));
    };

    const handleRemoveAllImages = () => {
        // Revoke all object URLs
        imagePreviews.forEach(preview => {
            if (preview.url && preview.url.startsWith('blob:')) {
                URL.revokeObjectURL(preview.url);
            }
        });

        // Clear all images
        setFormData(prev => ({
            ...prev,
            images: []
        }));
        setImagePreviews([]);

        // Clear the file input
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const data = new FormData();
            data.append("product_name", formData.product_name);
            data.append("description", formData.description);
            data.append("short_description", formData.short_description);
            data.append("price", formData.price);
            data.append("inventory", formData.inventory);
            data.append("category_id", formData.category_id);

            // Append each image file directly (like in Postman)
            formData.images.forEach((imageObj, index) => {
                // Use image[] to create an array of files
                data.append("image[]", imageObj.file);
            });

            for (let [key, value] of data.entries()) {
                console.log(`${key}:`, value instanceof File ? `File: ${value.name}` : value);
            }

            const endpoint = "https://leapatinternational.com/admin/api/v1/product_add.php";

            const response = await fetch(endpoint, {
                method: "POST",
                body: data, // Send as FormData with actual files
            });

            const result = await response.json();

            if (result.ok === true || result.status === "success") {
                toast.success("Product created successfully!");
                navigate('/dashboard/products');
            } else {
                toast.error(result.message || "Failed to create product");
            }
        } catch (err) {
            console.error("Error:", err);
            toast.error("Network error. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        if (onSectionChange) {
            onSectionChange("products");
        } else {
            navigate('/dashboard/products');
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="category-management-section">
            {/* Page Header */}
            <div className="row mb-4">
                <div className="col-12">
                    <div className="d-flex align-items-center justify-content-between mb-3">

                        <div>
                            <h1 className="page-title mb-0">
                                {isEdit ? "Edit Product" : "Add New Product"}
                            </h1>
                            <p className="page-subtitle mb-0">
                                {isEdit ? "Update product information" : "Create a new product listing"}
                            </p>
                        </div>
                        <button className="back-button me-3" onClick={handleCancel}>
                            ← Back to Products
                        </button>
                    </div>
                </div>
            </div>

            {/* Form */}
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="card-title mb-0">Product Information</h5>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    {/* Left Column */}
                                    <div className="col-md-6">
                                        <div className="mb-4">
                                            <label className="form-label">Product Name *</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="product_name"
                                                value={formData.product_name}
                                                onChange={handleInputChange}
                                                placeholder="Enter product name"
                                                required
                                            />
                                            <div className="form-text">Choose a clear, descriptive name for your product</div>
                                        </div>

                                        <div className="mb-4">
                                            <label className="form-label">Category *</label>
                                            <select
                                                className="form-select"
                                                name="category_id"
                                                value={formData.category_id}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">Select a category</option>
                                                {categories.map((category) => (
                                                    <option key={category.id} value={category.id}>
                                                        {category.title}
                                                    </option>
                                                ))}
                                            </select>
                                            <div className="form-text">Choose the most appropriate category for this product</div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-4">
                                                    <label className="form-label">Price *</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="price"
                                                        value={formData.price}
                                                        onChange={handleInputChange}
                                                        placeholder="0.00"
                                                        min="0"
                                                        step="0.01"
                                                        required
                                                    />
                                                    <div className="form-text">Enter product price</div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-4">
                                                    <label className="form-label">Inventory *</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="inventory"
                                                        value={formData.inventory}
                                                        onChange={handleInputChange}
                                                        placeholder="0"
                                                        min="0"
                                                        required
                                                    />
                                                    <div className="form-text">Available stock quantity</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right Column */}
                                    <div className="col-md-6">
                                        <div className="mb-4">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <label className="form-label mb-0">Product Images Gallery</label>
                                                {imagePreviews.length > 0 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-danger btn-sm"
                                                        onClick={handleRemoveAllImages}
                                                    >
                                                        Remove All
                                                    </button>
                                                )}
                                            </div>
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={handleImageUpload}
                                                multiple
                                            />
                                            <div className="form-text">
                                                Upload multiple product images (JPG, PNG, GIF).
                                                <br />
                                                <small className="text-muted">
                                                    {formData.images.length}/10 images selected
                                                </small>
                                                <br />
                                                <small className="text-info">
                                                    💡 You can select images multiple times to add more to your gallery
                                                </small>
                                            </div>

                                            {/* Image Gallery Preview */}
                                            {imagePreviews.length > 0 && (
                                                <div className="mt-3">
                                                    <label className="form-label">Image Gallery Preview</label>
                                                    <div className="row g-2">
                                                        {imagePreviews.map((preview) => (
                                                            <div key={preview.id} className="col-6 col-md-4">
                                                                <div className="position-relative">
                                                                    <img
                                                                        src={preview.url}
                                                                        alt={preview.name}
                                                                        className="img-thumbnail w-100"
                                                                        style={{
                                                                            height: "120px",
                                                                            objectFit: "cover",
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={() => {
                                                                            // Optional: Open image in modal for full view
                                                                            window.open(preview.url, '_blank');
                                                                        }}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1"
                                                                        onClick={() => handleRemoveImage(preview.id)}
                                                                        style={{
                                                                            width: "24px",
                                                                            height: "24px",
                                                                            padding: "0",
                                                                            fontSize: "12px",
                                                                            lineHeight: "1"
                                                                        }}
                                                                        title="Remove image"
                                                                    >
                                                                        ×
                                                                    </button>
                                                                    <div className="position-absolute bottom-0 start-0 end-0 bg-dark bg-opacity-75 text-white p-1">
                                                                        <small className="text-truncate d-block" style={{ fontSize: "10px" }}>
                                                                            {preview.name}
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Full Width Fields */}
                                <div className="mb-4">
                                    <label className="form-label">Short Description</label>
                                    <textarea
                                        className="form-control"
                                        name="short_description"
                                        value={formData.short_description}
                                        onChange={handleInputChange}
                                        rows="2"
                                        placeholder="Enter a brief product summary"
                                    ></textarea>
                                    <div className="form-text">Brief summary of the product (optional)</div>
                                </div>

                                <div className="mb-4">
                                    <label className="form-label">Product Description</label>
                                    <textarea
                                        className="form-control"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        rows="5"
                                        placeholder="Enter detailed product description"
                                    ></textarea>
                                    <div className="form-text">Provide detailed information about the product features and benefits</div>
                                </div>

                                <div className="d-flex gap-2 pt-3 border-top">
                                    <button type="submit" className="add-button" disabled={isSubmitting}>
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                {isEdit ? "Updating..." : "Creating..."}
                                            </>
                                        ) : (
                                            <>{isEdit ? "Update Product" : "Create Product"}</>
                                        )}
                                    </button>
                                    <button
                                        type="button"
                                        className="back-button pe-3 ps-3"
                                        onClick={handleCancel}
                                        disabled={isSubmitting}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}